import { connect } from 'react-redux';
import { ActiveFilters } from '@common/Filters/containers/ActiveFilters';

function ActiveFiltersBlock({
    activeFiltersCount
}) {
    return activeFiltersCount > 0
    && (
        <div className="filters__active">
            <ActiveFilters isGroupByType />
        </div>
    );
}

const getActiveFiltersCount = (activeFilters) => {
    if (activeFilters) {
        return activeFilters.filter(item => item.filterType !== 'personalcategory').length;
    }

    return 0;
};

const mapStateToProps = (state) => {
    const { activeFilters } = state.filters;

    return { activeFiltersCount: getActiveFiltersCount(activeFilters) };
};

export default connect(mapStateToProps)(ActiveFiltersBlock);
